export const USER_TYPE = {
  HEADQUARTER: "HQ",
  HEAD: "HEAD",
  SHOP: "SHOP",
  MANAGER: "MANAGER",
  NORMAL: "NORMAL",
  REGISTER_HEAD: "REGISTER_HEAD",
  REGISTER_NORMAL: "REGISTER_NORMAL",
  REGISTER_SHOP: "REGISTER_SHOP",
  VERIFY_PHONE_NUMBER: "VERIFY_PHONE_NUMBER",
};

export const PATH_LEVEL = {
  DEFAULT: "0",
  LITE: "1",
  BASIC: "2",
  STANDARD: "3",
  PREMIUM: "4",
};
